module.exports = "/assets/js/ac01212560dcdc7da3dc58deeaf22ad9.svg";